import React from 'react';
import SEO from '@americanexpress/react-seo';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import PropTypes from 'prop-types';
import { useDataFromOneCms } from '../../fetchye/useOneCmsFetchye';

const PageMeta = ({ selectedTab }) => {
  const { formatMessage } = useIntl();
  const locale = useSelector(getActiveLocaleSelector);
  const seoData = useDataFromOneCms('seo');
  const { title, description, canonical } = seoData?.[selectedTab] || {};

  return (
    <SEO
      title={title || seoData?.default?.title}
      description={description || seoData?.default?.description}
      canonical={canonical || seoData?.default?.canonical}
      twitterCard={{
        card: 'summary_large_image',
        site: '@AmericanExpress',
      }}
      robots={['index']}
      openGraph={{ siteName: formatMessage({ id: 'seoSiteName' }) }}
      locale={locale}
    />
  );
};

PageMeta.propTypes = {
  selectedTab: PropTypes.string.isRequired,
};

export default PageMeta;
